import { Breadcrumbs, Link as MuiLink, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link } from "react-router-dom";

/**
 * Breadcrumb navigation trail.
 *
 * Props:
 *   items - Array of { label: string, to?: string }
 *           The last item is treated as the current page (no link, muted colour).
 *           All other items are rendered as links.
 */
const AppBreadcrumbs = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" sx={{ color: "text.disabled" }} />}
      sx={{ mb: 2 }}
      aria-label="breadcrumb"
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        if (isLast) {
          return (
            <Typography
              key={item.label}
              variant="body2"
              sx={{ color: "text.primary" }}
            >
              {item.label}
            </Typography>
          );
        }

        return (
          <MuiLink
            key={item.label}
            component={Link}
            to={item.to}
            variant="body2"
            underline="hover"
            sx={{ color: "primary.main" }}
          >
            {item.label}
          </MuiLink>
        );
      })}
    </Breadcrumbs>
  );
};

export default AppBreadcrumbs;
